import { render, staticRenderFns } from "./Blockquote.vue?vue&type=template&id=60057d0b&scoped=true"
import script from "./Blockquote.vue?vue&type=script&lang=js"
export * from "./Blockquote.vue?vue&type=script&lang=js"
import style0 from "./Blockquote.vue?vue&type=style&index=0&id=60057d0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60057d0b",
  null
  
)

export default component.exports